import { AfterViewInit, ElementRef } from '@angular/core';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appStickyItem]'
})
export class StickyItemDirective implements AfterViewInit {

  private verticalScroll;
  private offset = 0;
  @Input() set stickyOffset(value: string) {
    if (!isNaN(Number(value))) {
      this.offset = Number(value)
    }
  }
  topValue = 0;

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');
    this.verticalScroll.addEventListener('scroll', e => {
      const pos = this.el.nativeElement.getBoundingClientRect();
      // usamos el offset si queremos que el elemento comience a descender antes de tocar el limite de la pantalla
      const top = pos.top - this.offset;
      if (top < 0) {
        // si el elemento se va de la vista, siempre ha de bajar, por lo que lo acumulamos
        this.topValue += Math.abs(top);
      } else {
        // si el elemento se encuentra a la vista, no sabemos si está en su punto inicial o no, usamos un clamp
        this.topValue = Math.max(0, this.topValue - top)
      }
      this.el.nativeElement.style.top = `${this.topValue}px`;
    });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/sticky-item.directive.ts